import "../../../css/teacherManagementPage/TeacherManagement.css"
import {useEffect, useState} from "react";
import TeacherDateSelector from "./TeacherDateSelector";
import TeacherList from "./TeacherList";
import {getDateString} from "../../../utils/Utils";
import proxy from "../../../utils/Proxy";
import Pagination from "../../footer/Pagination";
import TeacherRegisterModal from "./modal/TeacherRegisterModal";
import TableRegisterModal from "./modal/TableRegisterModal";

let TeacherManagementPage = (props) => {
    let defaultStartDate = new Date();
    let defaultEndDate = new Date();

    defaultStartDate.setMonth(defaultStartDate.getMonth() - 1);

    let [startDate, setStartDate] = useState(defaultStartDate);
    let [endDate, setEndDate] = useState(defaultEndDate);

    let [needUpdate, setNeedUpdate] = useState(false);
    let [teacherList, setTeacherList] = useState([]);

    let [page, setPage] = useState(1);
    let [listLength, setListLength] = useState(0);

    let [registerModalOpened, setRegisterModalOpened] = useState(false);
    let [tableModalOpened, setTableModalOpened] = useState(false);

    useEffect(() => {
        proxy.get("/adminapi/teachers?start=" + getDateString(startDate) + "&end=" + getDateString(endDate)
            + "&page=" + page + "&count=" + 8).then(res => {
            setTeacherList(res.data.data)
            setListLength(res.data.totalLength)
            setNeedUpdate(false)
        }).catch(error => {
            window.alert(error.response.data.message)
        })
    }, [needUpdate, page, startDate, endDate])

    return (<>
        <div className="content-container">
            <div className="teacher-management-header">
                <div className="title-selector-container">
                    <p className="content-title">강사 관리</p>
                    <div className="teacher-date-selector-container">
                        <TeacherDateSelector
                            date={startDate} setDate={setStartDate.bind(this)}
                        />
                        <TeacherDateSelector
                            date={endDate} setDate={setEndDate.bind(this)}
                        />
                    </div>
                </div>
                <div className="teacher-management-button" onClick={() => setTableModalOpened(true)}>
                    <p className="teacher-management-button-text">
                        <span className="plus">+</span>강사 시간표 관리</p>
                </div>
                <div className="teacher-management-button" onClick={() => setRegisterModalOpened(true)}>
                    <p className="teacher-management-button-text">
                        <span className="plus">+</span>강사 등록</p>
                </div>
            </div>
            <TeacherList setNeedUpdate={setNeedUpdate.bind(this)} teacherList={teacherList}
                         page={page} setPage={setPage.bind(this)} listLength={listLength}
                         data={props.data}
            />
            <div className="teacher-management-footer">
                <div className="teacher-list-pagination-container">
                    <Pagination setPage={setPage.bind(this)} page={page} listLength={listLength} countPerPage={8}/>
                </div>
            </div>
        </div>
        {registerModalOpened ?
            <TeacherRegisterModal setNeedUpdate={setNeedUpdate.bind(this)}
                                  setClosed={() => setRegisterModalOpened(false)}
            /> : null}
        {tableModalOpened ? <TableRegisterModal setClosed={() => setTableModalOpened(false)} data={props.data}/> : null}
    </>)
}
export default TeacherManagementPage